import { connect } from 'react-redux'
import { getProductList, setRowClickAble } from 'reduxpath/ducks/Product/List'

import AddFilterSortProduct from 'utils/AddFilterSortProduct'
import List from './units'


function mapStateToProps(state) {
  const productStatus = state.ProductList.status
  return {
    statusList: productStatus,
    product: state.ProductList,
    filter: state.ProductList.filter,
    sort: state.ProductList.sort,
    data: state.ProductList.data,
    search: state.ProductList.search,
    isLoading: state.ProductList.isLoading,
    searchProfileIds: state.ProductList.searchProfileIds,
    selectedCountry: state.Reference.selectedCountry,
    selectedService: state.Reference.selectedService,
    isRowClickable: state.ProductList.isRowClickable,
  }
}

const mapDispatchToProps = dispatch => ({
  handlePageChange(filter, sort) {
    return (key) => {
      const limit = 10
      let qs = {
        sort: {
          isEligible: 'DESC',
          createdAt: 'DESC',
        },
        limit,
        skip: key.selected * limit,
        where: {
          isEligible: true,
        },
      }

      qs = AddFilterSortProduct(qs, filter, sort)
      dispatch(getProductList(qs))
    }
  },

  setRowClickAble(data) {
    return () => {
      dispatch(setRowClickAble(data))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
